import React, { useState, useEffect } from 'react';
import { Layout } from 'antd';
import HeaderBar from '../components/HeaderBar';
import Sidebar from '../components/Sidebar'; // ← new horizontal tab component
import SubHeaderBar from '../components/SubHeaderBar';
import BacklogPage from '../pages/BacklogPage';
import TaskManagementDashboard from '../Board/TaskManagement';
// import Timelinedashboard from '../Timeline/Timelinedashboard';
import TimelineDashboard from '../Timeline/TimelineDashboard';
import SummaryDashboard from '../SummaryDashboard/SummaryDashboard';
// import SideBar from '../components/Sidebar';
import TaskManagementAdminDashboard from '../Board/TaskmanagementAdmin';
import Table from '../List/Table';
import ListWorkItems from './ListWorkItems';
import Content from 'antd/es/layout/layout';
import { Button } from "antd";

import ProjectTourProvider from 'components/ProjectTour/ProjectTourProvider'



// import ProductTour from 'components/ProductTour/ProductTour'
import ProductTour from 'components/ProductTour/ProductTour'
import {summarydashboardsteps} from '../../../../tours/SummaryDashboardSteps'
import {timelinesteps} from '../../../../tours/TimelineSteps'
import {backlogsteps} from '../../../../tours/BacklogSteps'
import {boardsteps} from '../../../../tours/BoardSteps'
import {liststeps} from '../../../../tours/ListSteps'



function setCookie(name, value, days = 7) {
  const expiry = new Date();
  expiry.setTime(expiry.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${value}; expires=${expiry.toUTCString()}; path=/`;
}

function getCookie(name) {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? match[2] : null;
}



const DashboardPage = () => {
  const [activeTab, setActiveTab] = useState('summaryDashboard');
  const roleId = Number(getCookie('task-role-id'));
  const [isAdminMode, setIsAdminMode] = useState(false);
  const [showLinkConfig, setShowLinkConfig] = useState(false);
 

  useEffect(() => {
  const isAutoTour =localStorage.getItem('has-seen-project-tour') === 'true';
  const savedTab = getCookie('activeTab');
  if (savedTab && !isAutoTour) {
    setActiveTab(savedTab);
  }
}, []);

const startProjectTourAgain = () => {

  window.dispatchEvent(new Event("restart-project-tour"));
};

  // save to cookie
  useEffect(() => {
    if (activeTab) setCookie('activeTab', activeTab, 7);
  }, [activeTab]);

//   const handleTabChange = (tab) => {
//   setActiveTab(tab);        // switch to the selected tab
//   setShowLinkConfig(false); // hide ListWorkItems when switching tabs
// };

const handleTabChange = (tab) => {
 

  setActiveTab(tab);
  setShowLinkConfig(false);
};




  return (
    <>
      {/* <HeaderBar /> */}
      <div style={{}}>
        {/* Horizontal TabBar placed below header */}
        <Sidebar activeTab={activeTab} setActiveTab={handleTabChange} />

        <div style={{ background: '#f5f5f5' }}>
          <SubHeaderBar activeTab={activeTab} openLinkConfig={() => setShowLinkConfig(true)} />

       <Content>
  {showLinkConfig ? (
    <ListWorkItems />
  ) : (
    <>
      {activeTab === 'Timeline' && <TimelineDashboard />}
      {activeTab === 'backlog' && <BacklogPage />}

      {activeTab === 'board' &&
        (roleId === 1 ? (
          isAdminMode ? (
            <TaskManagementAdminDashboard
              isAdminMode={isAdminMode}
              setIsAdminMode={setIsAdminMode}
            />
          ) : (
            <TaskManagementDashboard
              isAdminMode={isAdminMode}
              setIsAdminMode={setIsAdminMode}
            />
          )
        ) : (
          <TaskManagementDashboard />
        ))}

      {activeTab === 'summaryDashboard' && <SummaryDashboard />}
      {activeTab === 'list' && <Table />}
    </>
  )}
</Content>
        </div>
      </div>
      <ProjectTourProvider
    activeTab={activeTab}
    setActiveTab={setActiveTab}
/>
    
    </>
  );
};

export default DashboardPage;
